import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import FormControlLabel from "@mui/material/FormControlLabel";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@material-ui/core/Popper";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import { GET_TENANT_DATA_BY_USER } from "../../graphQL/tenant_qry";
import {
  GET_USER_DATA_BY_USERNAME,
  EDIT_USER_MUTATION,
  RESEND_ACTIVATION_EMAIL_MUTATION
} from "../../graphQL/register_qry";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const PopperMy = function (props) {
  return <Popper {...props} style={styles.popper} placement="bottom-start" />;
};
const styles = theme => ({
  popper: {
    width: "fit-content",
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1.5rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  largeButtonStyle: {
    borderRadius: 4,
    width: "220px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    marginLeft: 0,
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  autoComStyle: {
    "& .MuiAutocomplete-inputRoot": {
      borderRadius: 10,
    },
  },
}));

function UserEdit() {
  const classes = useStyles();
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const { userId } = useParams();

  const [loadContent, setLoadContent] = useState(false);
  const [alertResendMsg, setAlertResendMsg] = useState([]);
  const [alertMsg, setAlertMsg] = useState([]);
  const [errorMsg, setErrorMsg] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [originalEmail, setOriginalEmail] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [tenantStates, setTenantStates] = useState([]);
  const [tenantCountries, setTenantCountries] = useState([]);

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [editAccess, setEditAccess] = useState(true);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Staff",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      
      
      if(commonActions.find(a => a == "Edit")){
        setEditAccess(true); }
      else { setEditAccess(false); }
      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const [getUserTenantData] = useManualQuery(GET_TENANT_DATA_BY_USER, {
    fetchPolicy: "network-only",
  });
  const [getUserDataByUserName] = useManualQuery(GET_USER_DATA_BY_USERNAME, {
    fetchPolicy: "network-only",
  });
  const [editUser] = useMutation(EDIT_USER_MUTATION, {
    awaitRefetchQueries: true,
  });
  const [resendActivationEmail] = useMutation(RESEND_ACTIVATION_EMAIL_MUTATION, {
    awaitRefetchQueries: true,
  });

  const getUserData = async () => {
    // Get tenant information
    const {
      loading: tenantDataLoading,
      error: tenantDataError,
      data: tenantData,
    } = await getUserTenantData();

    if (!tenantDataLoading && tenantData && tenantData.getUserTenantData) {
      setTenantStates(tenantData.getUserTenantData.statesList.map(({ name }) => name));
      setTenantCountries(
        tenantData.getUserTenantData.countriesList.map(({ name }) => name)
      );
    }
    if (
      tenantDataError &&
      tenantDataError.graphQLErrors &&
      tenantDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }

    // Get user information
    const {
      loading: userDataLoading,
      error: userDataError,
      data: userData,
    } = await getUserDataByUserName({
      variables: { username: userId },
    });

    if (userData && !userData.getUserDataByUsername) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (
      userData &&
      userData.getUserDataByUsername &&
      userData.getUserDataByUsername == null
    ) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (!userDataLoading && userData && userData.getUserDataByUsername) {
      setLoadContent(true);
      setFirstName(userData.getUserDataByUsername.firstName);
      setLastName(userData.getUserDataByUsername.lastName);
      setOriginalEmail(userData.getUserDataByUsername.email);
      setEmail(userData.getUserDataByUsername.email);
      setPhoneNo(userData.getUserDataByUsername.phoneNo);
      setCity(userData.getUserDataByUsername.city);
      setState(userData.getUserDataByUsername.state);
      setCountry(userData.getUserDataByUsername.country);
    }

    if (
      userDataError &&
      userDataError.graphQLErrors &&
      userDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };

  useEffect(() => {
    (() => getUserData())();
  }, [userId]);

  const handleFirstNameChange = e => {
    setFirstName(e.target.value);
    if (e.target.value.toString().trim() === "") {
      setErrorMsg({ ...errorMsg, firstName: "First Name cannot be blank." });
    } else {
      setErrorMsg({ ...errorMsg, firstName: "" });
    }
  };

  const handleLastNameChange = e => {
    setLastName(e.target.value);
    if (e.target.value.toString().trim() === "") {
      setErrorMsg({ ...errorMsg, lastName: "Last Name cannot be blank." });
    } else {
      setErrorMsg({ ...errorMsg, lastName: "" });
    }
  };

  const handleEmailChange = e => {
    setEmail(e.target.value);
    if (e.target.value.toString().trim() === "") {
      setErrorMsg({ ...errorMsg, email: "Email cannot be blank." });
    } else {
      setErrorMsg({ ...errorMsg, email: "" });
    }
  };

  const handlePhoneChange = e => {
    setPhoneNo(e.target.value);
  };

  const handleCityChange = e => {
    setCity(e.target.value);
  };

  const handleStateChange = (event, value) => {
    setState(value);
  };

  const handleCountryChange = (event, value) => {
    setCountry(value);
  };

  const onSubmit = async formData => {
    if (firstName == "" || lastName == "" || email == "") {
      return;
    }
    const { data, error } = await editUser({
      variables: {
        username: userId,
        firstName: firstName,
        lastName: lastName,
        email: email,
        phoneNo: phoneNo,
        city: city,
        state: state,
        country: country,
      },
    });
    if (error && error.graphQLErrors) {
      if (error.graphQLErrors[0].message.includes("Email already exists!")) {
        setAlertMsg({
          title: "Email Validation",
          msg: "This email address cannot be saved, because it is already used by another resource.",
        });
      }
      else
      {
        console.log("Error", error, data);
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      }
    } else if (data && data.editUser) {
      setOriginalEmail(email);
      setEmail(email);
      console.log("Success", data);
      setAlertMsg({
        title: "Success",
        msg: "Staff has been successfully updated.",
      });
    }
  };
  
  const resendEmail = () => {
      setAlertResendMsg({
        title: "Resend Activation Email",
        type: "resendActivationConfirmation",
        msg: 'Are you sure you want to resend activation email for this user?',
        userFullname: firstName + " " + lastName,
        username: userId
      });
  };
  
  const submitResendEmail = async username => {
    const {
      loading: loadingResendEmail,
      error: errorResendEmail,
      data: dataResendEmail,
    } = await resendActivationEmail({
      variables: {
        username: username,
        tenantId: parseInt(tenantId)
      },
    });
    if (errorResendEmail && errorResendEmail.graphQLErrors) {
      setAlertMsg({
        title: "Error",
        msg: errorResendEmail.graphQLErrors[0].message,
      });
    } else if (!loadingResendEmail && dataResendEmail && dataResendEmail.resendActivationEmail) {
      setAlertMsg({
        title: "Success",
        msg: "Activation email is resent to Staff: " + firstName + " " +  lastName + ".",
      });
    }
  };
  
  if (loadContent)
    if (editAccess)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: firstName + " " + lastName, link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginBottom: 10 }}>
              Edit Staff
            </Typography>
          </Box>
          <Divider />
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid
              container
              spacing={3}
              style={{
                marginTop: 30,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid item xs={4} style={{ textAlign: "left"}}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.largeButtonStyle}
                    type="button"
                    onClick={() => resendEmail()}
                  >
                    Resend Activation Email
                  </Button>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="First Name"
                  margin="normal"
                  name="firstName"
                  type="text"
                  variant="outlined"
                  value={firstName}
                  id="firstName"
                  {...register("firstName")}
                  onChange={handleFirstNameChange}
                />
                {errorMsg.firstName && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.firstName}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Last Name"
                  margin="normal"
                  name="lastName"
                  type="text"
                  variant="outlined"
                  value={lastName}
                  id="lastName"
                  {...register("lastName")}
                  onChange={handleLastNameChange}
                />
                {errorMsg.lastName && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.lastName}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Email"
                  margin="normal"
                  name="email"
                  type="email"
                  variant="outlined"
                  value={email}
                  id="email"
                  {...register("email", {
                    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  })}
                  onChange={handleEmailChange}
                />
                {errors.email && errors.email.type === "pattern" && (
                  <Box>
                    <FormHelperText className={classes.errorStyle} error>
                      Invalid email format.
                    </FormHelperText>
                  </Box>
                )}
                {errorMsg.email && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.email}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Phone Number"
                  margin="normal"
                  name="phoneNo"
                  type="text"
                  variant="outlined"
                  value={phoneNo}
                  id="phoneNo"
                  {...register("phoneNo")}
                  onChange={handlePhoneChange}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="City"
                  margin="normal"
                  name="city"
                  type="text"
                  variant="outlined"
                  value={city}
                  id="city"
                  {...register("city")}
                  onChange={handleCityChange}
                />
              </Grid>
              <Grid item xs={4}>
                <form noValidate autoComplete="off">
                  <Autocomplete
                    className={classes.autoComStyle}
                    //key={selectedVal}
                    value={state}
                    options={tenantStates}
                    PopperComponent={PopperMy}
                    getOptionLabel={option => (option ? option : "")}
                    onChange={handleStateChange}
                    renderInput={params => (
                      <TextField
                        label="State"
                        margin="normal"
                        name="selectOptions"
                        variant="outlined"
                        {...params}
                        id="state"
                        {...register("state")}
                      />
                    )}
                  />
                </form>
              </Grid>
              <Grid item xs={4}>
                <form noValidate autoComplete="off">
                  <Autocomplete
                    className={classes.autoComStyle}
                    //key={selectedVal}
                    value={country}
                    options={tenantCountries}
                    PopperComponent={PopperMy}
                    getOptionLabel={option => (option ? option : "")}
                    onChange={handleCountryChange}
                    renderInput={params => (
                      <TextField
                        label="Country"
                        margin="normal"
                        name="selectOptions"
                        variant="outlined"
                        {...params}
                        id="country"
                        {...register("country")}
                      />
                    )}
                  />
                </form>
              </Grid>
            </Grid>
            <Box pt={4} pb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                type="submit"
              >
                Save
              </Button>

              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={() => navigate(`${project_url}/staff`)}
              >
                Cancel
              </Button>
            </Box>
          </form>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
                alertMsg.title === "Success" && navigate(`${project_url}/staff`);
                alertMsg.title === "Email Validation" && setEmail(originalEmail);
              }}
            />
          )}
          {alertResendMsg.msg && (
            <AlertDialog
              title={alertResendMsg.title}
              type={alertResendMsg.type}
              headerMsg={alertResendMsg.userFullname}
              contentMsg={alertResendMsg.msg}
              closeDialog={() => setAlertResendMsg([])}
              resendAction={() => {
                setAlertResendMsg([]);
                submitResendEmail(alertResendMsg.username);
              }}
            />
          )}
        </div>
      </div>
    );
  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default UserEdit;
